import React from "react";
import "./slider.css";

const Slides = () => {
  const slides = [
    { img: "https://www.computerhope.com/jargon/j/javascript.png", text: "Javascript" },
    { img: "/images/html-logo.png", text: "HTML" },
    { img: "/images/css.png", text: "CSS" },
    { img: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png", text: "React" },
    { img: "https://images.opencollective.com/chakra-ui-pro/61bd1dd/logo/256.png", text: "Chakra-UI" },
    { img: "https://ubunlog.com/wp-content/uploads/2020/04/about-nodejs.png", text: "NodeJs" },
    { img: "https://styles.redditmedia.com/t5_2rjwd/styles/communityIcon_vekzf3oatrs61.png", text: "MongoDB" },
    { img: "https://media.trustradius.com/product-logos/h3/JA/T1A83W5H538P.PNG", text: "Postman" },
    { img: "https://cms-assets.tutsplus.com/uploads/users/34/posts/29738/preview_image/nodejs-expressjs.jpg", text: "ExpressJs" },
    { img: "/images/redux-logo.png", text: "Redux" }
  ];

  // Duplicate slides for infinite loop effect
  const repeatedSlides = [...slides, ...slides];

  return (
    <div className="skill-container" id="skill">
      <h1 className="slide_h1">TECH STACK</h1>
      <div className="slider">
        <div className="slide-track">
          {repeatedSlides.map((slide, index) => (
            <div className="slide1" key={index}>
              <img src={slide.img} alt={slide.text} />
              <h3 className="tack-name">{slide.text}</h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slides;
